import { useArgonController } from "context";
import { setMiniSidenav } from "context";
import Sidenav from "examples/Sidenav";
import { CustomDescrypt } from "global/func";
import { useEffect, useState } from "react";
import { decodeToken, isExpired } from "react-jwt";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import logo from "assets/images/logo-buton.png";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import userStore from 'store/userStore';
import TahunAnggaran from "pages/TahunAnggaran";
import adminPembangunanRoutes from "./adminPembangunanRoutes";
import Dashboard from "./Dashboard";
import LokasiPekerjaan from "pages/superAdmin/LokasiPekerjaan";
import Perencanaan from "./PerencanaanOPD";
import Laporan from "./Laporan";
import Belanja from "./PaketPekerjaan/Belanja";
import BelanjaModal from "./PaketPekerjaan/BelanjaModal";
import ProjekStrategis from "./PaketPekerjaan/ProjekStrategis";
import PaketDak from "./PaketPekerjaan/PaketDak";

const TemplateAdminPembangunan = () => {
    const { user, tahunAnggaran, reqCount } = userStore(state => ({ user: state.user, tahunAnggaran: state.tahunAnggaran, reqCount: state.reqCount }));
    const logOut = userStore((state) => state.logOut)
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));
    const [decodedUser] = useState(decodeToken(decryptedUser));

    const navigate = useNavigate();
    const location = useLocation();
    const [controller, dispatch] = useArgonController();
    const { miniSidenav, sidenavColor } = controller;
    const [onMouseEnter, setOnMouseEnter] = useState(false);

    useEffect(() => {
        console.log(reqCount);
        if (user === null || user === undefined || user === '') {
            navigate("/", { replace: true });
        }
        else {
            if (isExpired(decryptedUser)) {
                console.log(isExpired(decryptedUser));
                logOut()
                navigate("/", { replace: true });
            }
            else {
                if (decodedUser.role !== 'admin_pembangunan') {
                    navigate("/", { replace: true });
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user, location, reqCount])

    const handleOnMouseEnter = () => {
        if (miniSidenav && !onMouseEnter) {
            setMiniSidenav(dispatch, false);
            setOnMouseEnter(true);
        }
    };

    // Close sidenav when mouse leave mini sidenav
    const handleOnMouseLeave = () => {
        if (onMouseEnter) {
            setMiniSidenav(dispatch, true);
            setOnMouseEnter(false);
        }
    };
    return (
        tahunAnggaran === null ?
            <>
                <TahunAnggaran />
            </>
            :
            <>
                <Sidenav
                    color={sidenavColor}
                    brand={logo}
                    brandName="TEPRA Kab. Buton"
                    routes={adminPembangunanRoutes}
                    onMouseEnter={handleOnMouseEnter}
                    onMouseLeave={handleOnMouseLeave}
                />
                <DashboardLayout>
                    <DashboardNavbar homePage='/a-pemb' isMini={miniSidenav} user={decodedUser.nama || ''} dinas={decodedUser.nm_pd || ""} loginId={decodedUser.id || ''} />
                    <Routes>
                        <Route path="" element={<Dashboard />} />
                        <Route path="lokasi-pekerjaan/*" element={<LokasiPekerjaan />} />
                        <Route path="perencanaan/*" element={<Perencanaan />} />
                        <Route path="laporan/*" element={<Laporan />} />
                        <Route path="belanja/*" element={<Belanja />} />
                        <Route path="belanja-modal/*" element={<BelanjaModal />} />
                        <Route path="proyek-strategis/*" element={<ProjekStrategis />} />
                        <Route path="proyek-dak/*" element={<PaketDak />} />
                    </Routes>
                </DashboardLayout>
            </>
    )
}

export default TemplateAdminPembangunan